import React from 'react';
import { cn } from '@/lib/utils';
import { getColorClasses } from '@/lib/design-system';

interface TrustIndicatorProps {
  icon?: React.ReactNode;
  text: string;
  variant?: 'success' | 'primary' | 'warning' | 'danger';
  animated?: boolean;
  className?: string;
}

export const TrustIndicator: React.FC<TrustIndicatorProps> = ({
  icon,
  text,
  variant = 'success',
  animated = true,
  className,
}) => {
  const variantClasses = {
    success: cn(
      'bg-brand-success/10',
      getColorClasses.border.success(),
      'border-opacity-20',
      getColorClasses.text.success()
    ),
    primary: cn(
      'bg-brand-primary/10',
      getColorClasses.border.primary(),
      'border-opacity-20',
      getColorClasses.text.primary()
    ),
    warning: cn(
      'bg-brand-warning/10',
      getColorClasses.border.warning(),
      'border-opacity-20',
      getColorClasses.text.warning()
    ),
    danger: cn(
      'bg-brand-danger/10',
      getColorClasses.border.danger(),
      'border-opacity-20',
      getColorClasses.text.danger()
    ),
  };

  const dotColors = {
    success: 'bg-brand-success',
    primary: 'bg-brand-primary',
    warning: 'bg-brand-warning',
    danger: 'bg-brand-danger',
  };

  return (
    <div
      className={cn(
        'flex items-center gap-2 px-3 py-2 rounded-full border font-medium text-sm',
        variantClasses[variant],
        className
      )}
    >
      {icon ? (
        <span className='flex-shrink-0'>{icon}</span>
      ) : (
        <div
          className={cn(
            'w-3 h-3 rounded-full flex-shrink-0',
            dotColors[variant],
            animated && 'animate-pulse'
          )}
        />
      )}
      <span>{text}</span>
    </div>
  );
};
